import { useCallback } from "react"

interface FileProps {
  fileName: string
  fileType: string
}

export const useExportFile = (fileProps: FileProps) => {
  const { fileName, fileType } = fileProps

  const downloadFileOnClick = useCallback(
    (data: string) => {
      const blob = new Blob([data], { type: fileType })

      const a = document.createElement("a")

      a.download = fileName
      a.href = window.URL.createObjectURL(blob)

      const clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true
      })

      a.dispatchEvent(clickEvent)
      a.remove()
    },
    [fileName, fileType]
  )

  const downloadFileByLink = useCallback(
    (url: string) => {
      const link = document.createElement("a")

      link.href = url
      link.download = fileName
      link.target = "_blank"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    [fileName]
  )

  return {
    downloadFileOnClick,
    downloadFileByLink
  }
}
